(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('impulse-media-slideshow')) {
    customElements.define('impulse-media-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        this.hovered = false;
        this.focused = false;
        this.inView = !('IntersectionObserver' in window);
        this.editor = Boolean(window.Shopify && Shopify.designMode);
        this.querySelector('[data-navigation]')?.removeAttribute('hidden');
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-prev')) this.show(this.index - 1, true);
          if (button.hasAttribute('data-next')) this.show(this.index + 1, true);
          if (button.hasAttribute('data-go')) this.show(Number(button.dataset.go), true);
          if (button.hasAttribute('data-pause')) {
            this.paused = !this.paused;
            this.updatePause();
            this.schedule();
          }
        }, {signal});
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, {signal});
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, {signal});
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, {signal});
        this.mobile.addEventListener('change', () => this.show(this.index), {signal});
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) this.paused = true;
          this.updatePause(); this.syncVideo(); this.schedule();
        }, {signal});
        document.addEventListener('visibilitychange', () => { this.syncVideo(); this.schedule(); }, {signal});
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index);
        }, {signal});
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.syncVideo(); this.schedule();
          }, {threshold:0.05});
          this.observer.observe(this);
        }
        this.updatePause();
        this.show(0);
      }
      show(index, announce = false) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
          if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        this.querySelectorAll('[data-go]').forEach(button => {
          if (Number(button.dataset.go) === this.index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        if (announce) this.querySelector('[data-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
        this.syncVideo();
        this.schedule();
      }
      syncVideo() {
        const slide = this.slides[this.index];
        const device = this.mobile.matches ? 'mobile' : 'desktop';
        const video = slide?.querySelector(`[data-media="${device}"] video`);
        this.querySelectorAll('video').forEach(other => {
          if (other !== video) other.pause();
        });
        if (!video) return;
        if (!this.inView || document.hidden) { video.pause(); return; }
        if (slide.dataset.videoAutoplay === 'true' && !this.reduced.matches && !this.editor) {
          video.muted = true;
          const play = video.play();
          if (play) play.catch(() => {});
        } else if (this.reduced.matches) video.pause();
      }
      updatePause() {
        const button = this.querySelector('[data-pause]');
        if (!button) return;
        button.textContent = this.paused ? 'Play' : 'Pause';
        button.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editor || !this.inView || document.hidden) return;
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
